const SET_CLIENT_CONFIG = 'client-config/SET_CLIENT_CONFIG';

export default {
  SET_CLIENT_CONFIG,
};
